/**
 * Shared helper functions and constants for citation components.
 */

/**
 * Citation status color config used across spark chart, dropdown, and hover card.
 *
 * - match: source value agrees with the field value (green)
 * - conflict: source value disagrees with the field value (amber)
 * - sourceOfTruth: designated authoritative source (blue)
 * - empty: no value found in this source (stone)
 */
export const citationStatusColors = {
  match: {
    bg: "bg-green-500 dark:bg-green-400",
    ring: "ring-green-800/60 dark:ring-green-200/60",
    dot: "bg-green-900 dark:bg-green-100",
    text: "text-green-600 dark:text-green-400",
  },
  conflict: {
    bg: "bg-amber-500 dark:bg-amber-400",
    ring: "ring-amber-800/60 dark:ring-amber-200/60",
    dot: "bg-amber-900 dark:bg-amber-100",
    text: "text-amber-600 dark:text-amber-400",
  },
  sourceOfTruth: {
    bg: "bg-blue-500 dark:bg-blue-400",
    ring: "ring-blue-800/60 dark:ring-blue-200/60",
    text: "text-blue-600 dark:text-blue-400",
  },
  empty: {
    bg: "border border-stone-300 dark:border-stone-600 bg-transparent",
    ring: "ring-stone-500/60",
    dot: "bg-stone-500 dark:bg-stone-400",
  },
} as const;

/**
 * Get the appropriate color class for a confidence percentage.
 */
export function getConfidenceColorClass(confidencePercent: number): string {
  if (confidencePercent >= 90) {
    return citationStatusColors.match.text;
  }
  if (confidencePercent >= 70) {
    return "text-stone-500 dark:text-stone-400";
  }
  return citationStatusColors.conflict.text;
}
